export default __webpack_public_path__ + "static/media/Rain.e8330033.svg";